mutation UpdateCustomFieldPositions($input: CustomFieldUpdatePositionInput!) {
    updateCustomFieldPositions(input: $input) {
        success
    }
}
